import G6 from "@antv/g6";
import {MeterTreeItem} from "../../../meter/components/common/G6Help2";

const menu = (that)=>{
  return new G6.Menu({
    offsetX: 6,
    offsetY: 10,
    itemTypes: ['node'],
    getContent(e) {
      const outDiv = document.createElement('div');
      outDiv.style.width = '180px';
      outDiv.innerHTML = `<ul>
        <li code="editorNode">本级表</li>
        <li code="editorParentNode">父级表</li>
      </ul>`
      return outDiv
    },
    shouldBegin(e){
      const { item, target } = e;
      const targetType = target.get('type');
      return targetType!=='image'
    },
    handleMenuClick(target, item) {
      const model=item.getModel();
      const code=target.getAttribute("code")
      // console.log(target, item)
      if(code==='settingSon'){
        if (!model.children) {
          model.children = [];
        }
        that.$refs.SelectMeter.show(list=>{
          let meter_ids=list.map(ret=>ret.id);
          that.addPid(model.id,meter_ids,()=>{
            let energy_list=["业主能耗","物业能耗","分摊能耗"];
            list.forEach(ret=>{
              model.children.push(MeterTreeItem(ret,list));
            })
            that.treeGraph.updateChild(model, model.id);
          })
        })
      }else if(code==='deleteItem'){
        that.$confirm('是否确认移除', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          that.deleteMeterPid(model.id,()=>{
            that.treeGraph.removeChild(model.id);
          })
        })
      }else if(code==='settingObject'){
        that.$refs.ApportionWinRef.show({id:model.id,name:model.name,number:model.number})
      }else if(code==='editorMeter'){
        that.$refs.MeterEditorRef.show({id:model.id},true)
      }else if(code==='editorNode'){
        // that.$emit("onClickMeterId",model.id)
        that.renderData(model.id)
      }else if(code==='editorParentNode'){
        if(model.upid){
          // that.$emit("onClickMeterId",model.upid)
          that.renderData(model.upid)
        }else {
          that.$message.error("无上级了")
        }


      }


    },
  })
};
const tooltip = new G6.Tooltip({
  offsetX: 10,
  offsetY: 20,
  getContent(e) {
    const { item, target } = e;
    const targetType = target.get('type');
    const name = target.get('name');
    const model=item.getModel();
    if(targetType==='image'){
      if(name==='add-item'){
        return '添加下级表';
      }else if(name==='add-user'){
        return '设置收费对象';
      }else {
        return '移除挂载';
      }
    }else {
      // return '仪表名称: ' + model.name + '<br/> ' +
      //   '仪表编号: ' + model.number+ '<br/> ' +
      //   '能耗类型: ' + model.energy+ '<br/> ' +
      //   '下级数量: ' + model.children_count+ '<br/> ' +
      //   '分摊类型: ' + model.apportion_meter_type+ '<br/> ' +
      //   '分摊模式: ' + model.apportion_type+ '<br/> ' +
      //   '分摊人数: ' + model.customer_count+ '<br/> ' +
      //   '所在级别: ' + model.depth+ '<br/> '+
      //   '上期读数: ' + model.last_read_number+ '<br/> '+
      //   '本期读数: ' + model.read_number+ '<br/> '+
      //   '仪表用量: ' + model.dosage_number+ '<br/> '+
      //   '线损用量: ' + model.x_dosage_number+ '<br/> '+
      //   '计算公式: ' + model.dosage_fun_name+ '<br/> '+
      //   '线损分摊: ' + model.x_only_dosage_number+ '<br/> '+
      //   '线损累计: ' + model.x_total_dosage_number+ '<br/> '+
      //   '线损系数: ' + model.proportion_value+ '<br/> '+
      //   '线损基数: ' + model.proportion_total+ '<br/> '+
      //   '线损占比: ' + model.proportion+ '<br/> '+
      //   '线损模式: ' + model.mol_apportion_type+ '<br/> '+
      //   '本表单价: ' + model.current_price+ '<br/> '+
      //   '总分摊量: ' + model.total_dosage_number+ '<br/> '+
      //   '计费总额: ' + model.total_amount+ '<br/> '+
      //   '分摊总金额: ' + model.allocated_amount+ '<br/> '+
      //   ''
      //   ;
      let _html='';
      model.order_list.map(ret=>{
        _html+=`<div>${ret.charge_name}: <span style="color:red">${ret.allocated_amount}</span></div>`;
      })
      let html=`<div style="max-width: 500px;">
        <div>仪表名称: ${model.name}</div>
        <div>仪表编号: ${model.number}</div>
        <div>能耗类型: ${model.energy}</div>
        <div>下级数量: ${model.children_count}</div>
        <div>分摊类型: ${model.apportion_meter_type}</div>
        <div>分摊模式: ${model.apportion_type}</div>
        <div>分摊人数: ${model.customer_count}</div>
        <div>所在级别: ${model.depth}</div>
        <hr/>
        <div>线损系数: ${model.proportion_value}</div>
        <div>线损基数: ${model.proportion_total}</div>
        <div>线损占比: ${model.proportion}</div>
        <div>线损模式: ${model.mol_apportion_type}</div>
        <hr/>
        <div>上期读数: ${model.last_read_number}</div>
        <div>本期读数: ${model.read_number}</div>
        <div>仪表用量: ${model.dosage_number}</div>
        <div>线损用量: ${model.x_dosage_number}</div>
        <div>计算公式: ${model.dosage_fun_name}</div>
        <div>线损分摊: ${model.x_only_dosage_number}</div>
        <div>线损累计: ${model.x_total_dosage_number}</div>
        <hr/>
        <div>本表单价: ${model.current_price}</div>
        <div>总分摊量: ${model.total_dosage_number}</div>
        <div>计费总额: ${model.total_amount}</div>
        <hr/>
        <div>
          ${_html}
        </div>
        <hr/>
        <div>分摊总金额: <span style="color:red">${model.allocated_amount}</span></div>
      </div>`;
      return html;

    }

  },
  shouldBegin(e){
    const { item, target } = e;
    const targetType = target.get('type');
    return true;
  },
  itemTypes: ['node']
});

export {
  tooltip,menu
}



// WEBPACK FOOTER //
// ./src/components/Admin/EnergyConsumption/components/meter_order/components/common/MeterOrderG6.js